import {Injectable} from '@angular/core';

/**
 * Translations for salutations.
 */
@Injectable()
export class SalutationsTranslationService {
  public mr: any = $localize`:@@general.text.mr:Mr.`;
  public mrs: any = $localize`:@@general.text.mrs:Mrs.`;
  constructor() { }
}
